// extracted by mini-css-extract-plugin
module.exports = {"table":"BasicTable_table__2jLcl"};